import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AppFrameContextService, CommonBrowserStorageService, DialogService } from "@sdbn/common";
import { GKCFindElementByQrCameraPickerDialogComponent } from "../gkc-camera-picker-dialog/gkc-camera-picker-dialog.component";

@Component({
    selector: 'app-gate-keeper-control-find-element-by-qr-camera-picker',
    templateUrl: './gkc-camera-picker.component.html',
    styleUrls: ['./gkc-camera-picker.component.scss'],
    standalone: false
})
export class GKCFindElementByQrCameraPickerComponent implements OnInit {

  private availableCameras: MediaDeviceInfo[] = [];
  private selectedCamera: MediaDeviceInfo;

  @Output() deviceSelected = new EventEmitter<MediaDeviceInfo>();


  constructor(
    private dialogService: DialogService,
    private appFrameContextService: AppFrameContextService,
    private commonBrowserStorageService: CommonBrowserStorageService) { }

  ngOnInit(): void {
    this.getCameras().then(cameras => {

      this.availableCameras = cameras;

      let cameraId = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control-find-element', 'camera-id');
      if (cameraId !== undefined) {

        const selectedCamera = cameras.find(cam => cam.deviceId === cameraId);
        if (selectedCamera) {
          this.selectedCamera = selectedCamera;
          this.deviceSelected.emit(selectedCamera);
        } else {
          this.showDeviceSelector();
        }
      }
    });
  }

  showDeviceSelector() {
    const data = { availableCameras: this.availableCameras, selectedCamera: this.selectedCamera };
    this.dialogService.openMaxHeight(GKCFindElementByQrCameraPickerDialogComponent, data).afterClosed().subscribe(result => {
      if (result != null) {
        this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control-find-element', 'camera-id', result.deviceId);
        this.deviceSelected.emit(result);
      }
    });

  }


  async getCameras(): Promise<MediaDeviceInfo[]> {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        throw new Error('MediaDevices API wird nicht unterstützt.');
      }
      await navigator.mediaDevices.getUserMedia({video: { facingMode: { ideal: 'environment' } }}); // Vorselektion/ Triggern der Permission Abfrage beim User
      const devices = await navigator.mediaDevices.enumerateDevices();

      const cameras = devices.filter(device => device.kind === 'videoinput');

      return cameras;
    } catch (error) {
      console.error('Fehler beim Abrufen der Kameras:', error);
      // Hinweistext, z.B. auf Permissions in Systemeinstellungen anzeigen?
      return [];
    }
  }



}
